// Shared client-side mirror of the backend's password rules
// (viewmodel.ChangePasswordRequest / ResetPasswordRequest): minimum 8 runes,
// not blank, and bcrypt's 72-byte maximum. Used by both the account
// change-password form and the reset-password form so the two never drift
// apart into two different policies.

// bcrypt's own input limit, mirrored client-side so an oversized password is
// caught before the network round trip rather than surfacing as a bare 422.
export const MAX_PASSWORD_BYTES = 72;

export function utf8ByteLength(value: string): number {
  return new TextEncoder().encode(value).length;
}

// Backend's "notblank" validator rejects a whitespace-only value even though
// it is non-empty.
export function isBlank(value: string): boolean {
  return value.trim() === "";
}

// Backend's "min" validator counts Unicode code points (Go rune count), not
// UTF-16 code units. JS string .length counts UTF-16 code units, so it
// under-mirrors the backend rule for characters outside the BMP (e.g. most
// emoji). Array.from splits by code point, matching the backend's count.
export function runeLength(value: string): number {
  return Array.from(value).length;
}
